import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import Sidebar from "./Sidebar";
import ParticlesBackground from "@/components/ParticlesBackground";
import ScrollProgress from "@/components/ScrollProgress";
import BackToTop from "@/components/BackToTop";
import PageTransition from "@/components/PageTransition";

export default function PublicLayout() {
  const { pathname } = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="bg-atelier text-atelier-text min-h-screen relative">
      {/* Background layers */}
      <ParticlesBackground />
      <div className="fixed inset-0 paper-texture z-[1] pointer-events-none" aria-hidden="true" />
      <div className="fixed inset-0 blueprint-grid-soft pointer-events-none z-[1]" aria-hidden="true" />
      <div className="scanline-overlay" aria-hidden="true" />

      {/* UX overlays */}
      <ScrollProgress />
      <PageTransition />

      {/* Sidebar (drawer on mobile, fixed on desktop) */}
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      {/* Main column */}
      <div className="lg:pl-72 flex flex-col min-h-screen relative z-10">
        <Header onMenuToggle={() => setSidebarOpen(true)} />
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
      </div>

      {/* Floating UI */}
      <BackToTop />
    </div>
  );
}
